export default "__VITE_ASSET__DZfVNPlx__"